import styled from "styled-components";
import { addClassName } from "../../../../themes/common";

export const PriceDetails = styled.div.attrs(addClassName("priceDetails"))``;

export const BasePrice = styled.span.attrs(addClassName("base-price"))``;

export const Price = styled.span.attrs(addClassName("price"))``;

export const CrossedPrice = styled.span.attrs(addClassName("crossedPrice"))``;

export const RealPrice = styled.span.attrs(addClassName("real-price"))``;

export const MonthlyPriceWrapper = styled.div`
    display: flex;
`;
